import React from 'react';

import { Icon } from '@rbilabs/universal-components';
import { StyleSheet } from 'react-native';

import { Box, Typography } from 'components/ui';
import { getDesignToken, primitive } from 'styles/constants';

import UnstyledButton from '../unstyled-button';

const Container = UnstyledButton.withConfig(() => ({
  paddingY: '5',
  borderBottomWidth: '1px',
  borderBottomColor: primitive.$greyFour,
}));

export const ArrowButton: React.FC<React.PropsWithChildren<
  React.ComponentProps<typeof UnstyledButton>
>> = ({ children, ...props }) => {
  const content =
    typeof children === 'string' ? (
      <Typography numberOfLines={1} style={styles.mainContentText}>
        {children}
      </Typography>
    ) : (
      children
    );

  return (
    <Container {...props}>
      <Box style={styles.row}>
        <Box style={styles.mainContent}>{content}</Box>
        <Icon variant="next" color={getDesignToken('icon-default')} accessible={false} />
      </Box>
    </Container>
  );
};

const styles = StyleSheet.create({
  row: { alignItems: 'center', flexDirection: 'row', justifyContent: 'space-between' },
  mainContent: { width: '90%' },
  mainContentText: { color: primitive.$greyOne, textAlign: 'left', textDecorationLine: 'none' },
});
